export function formatMoney(amount: number) {
    // formatMoney 1.000.000d
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
}

export function formatPoint(point: number) {
    // formatPoint 846505.99 => 846,505
    return new Intl.NumberFormat('vi-VN').format(point);
}
